
























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppFormCard
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop() readonly cancelType!: string
  @Prop() readonly cancelReasonDetail!: string
  cancelReasonList: string[] = []

  mounted () {
    if (this.cancelType === 'REFUND') {
      this.cancelReasonList.push('CHANGING_MIND', 'MISTAKE', 'DELIVERY', 'OUT_OF_STOCK')
    } else {
      this.cancelReasonList.push('CHANGING_MIND', 'MISTAKE', 'BAD_GOODS', 'WRONG_DELIVERY')
    }
  }
}
